import type { Seo } from 'core/domains/config';

export const insertSeoMetaTags = (seo: Seo) => {
  const head = document.getElementsByTagName('head')[0];
  Object.entries(seo.meta).forEach(([name, content]) => {
    const newNode = document.createElement('meta');
    newNode.setAttribute('content', content);
    newNode.setAttribute('name', name);
    head.appendChild(newNode);
  });

  seo.links.forEach((link) => {
    const newNode = document.createElement('link');
    Object.entries(link).forEach(([key, value]) => {
      newNode.setAttribute(key, value);
    });
    head.appendChild(newNode);
  });
  const hasTitle = document.getElementsByTagName('title')[0];
  const title = hasTitle ? hasTitle : document.createElement('title');

  title.textContent = seo.title;
  if (!hasTitle) {
    head.appendChild(title);
  }
};
